import { gql } from "@apollo/client";

export const GET_NOTIFICATION_INFO = gql`
  query {
    getCurrentSitePromoInfo {
      title
      subtitle
      startTime
      endTime
      imageUrl
      linkTo
      backgroundColor
      textColor
    }
  }
`;
